import { ScopeThreeWasteTreatmentEnums } from "enums/ScopeThreeWasteTreatmentsEnums";

export const wasteTreatmentOptions = [
    {
        label: "Recycled", value: ScopeThreeWasteTreatmentEnums.RECYCLED
    },
    {
        label: "Landfilled", value: ScopeThreeWasteTreatmentEnums.LANDFILLED
    },
    {
        label: "Combusted", value: ScopeThreeWasteTreatmentEnums.COMBUSTED
    },
    {
        label: "Composted", value: ScopeThreeWasteTreatmentEnums.COMPOSTED
    },
    {
        label: "Anaerobically Digested Dry", value: ScopeThreeWasteTreatmentEnums.ANAEROBICALLY_DIGESTED_DRY
    },
    {
        label: "Anaerobically Digested Wet", value: ScopeThreeWasteTreatmentEnums.ANAEROBICALLY_DIGESTED_WET
    }
]